module.exports = __webpack_public_path__ + "static/media/questionnaire_medical_simplifie.9f38aa2d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/adhesion/questionnaire_medical_simplifie.pdf
// module id = 846
// module chunks = 40